import React from 'react';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

// Surfaces the reason behind a silent logout (token expiry, corrupted
// token) instead of letting the user just appear logged out with no
// explanation. Non-blocking — this app is mostly public browsing, so
// unlike the admin panel, there's no reason to force a redirect.
function SessionExpiredBanner() {
  const { sessionMessage, clearSessionMessage } = useAuth();

  if (!sessionMessage) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      dismissible
      onClose={clearSessionMessage}
      className="mb-0 rounded-0 text-center"
    >
      {sessionMessage}
    </Alert>
  );
}

export default SessionExpiredBanner;
